import service from "../utils/request";

/**
 * API接口统一管理
 */
export default {
  // =================== 互联网+模块 ===================
  
  // 首页相关
  index(params) {
    return service({
      url: "/index",
      method: "post",
      data: params
    });
  },

  indexPage(params) {
    return service({
      url: "/index/page",
      method: "post",
      data: params
    });
  },

  // 轮播图
  indexAd(params) {
    return service({
      url: "/index/ad",
      method: "get",
      params
    });
  },

  // 用户评价
  indexMsg(params) {
    return service({
      url: "/index/msg",
      method: "get",
      params
    });
  },

  indexMsgadd(params) {
    return service({
      url: "/index/msgadd",
      method: "post",
      data: params
    });
  },

  // 文件详情
  info(params) {
    return service({
      url: "/info",
      method: "get",
      params
    });
  },

  detail(params) {
    return service({
      url: "/detail",
      method: "get",
      params
    });
  },

  preview(params) {
    return service({
      url: "/preview",
      method: "get",
      params: params.params || params
    });
  },

  recomm(params) {
    return service({
      url: "/recomm",
      method: "get",
      params: params.params || params
    });
  },

  // 用户行为
  like(params) {
    return service({
      url: "/like",
      method: "post",
      data: params
    });
  },

  dl(params) {
    return service({
      url: "/dl",
      method: "post",
      data: params
    });
  },

  // =================== 职规赛模块 ===================
  
  // 职规赛首页
  zyghIndex(params) {
    return service({
      url: "/v2/index",
      method: "post",
      data: params
    });
  },

  zyghIndex1(params) {
    return service({
      url: "/v2/index1",
      method: "post",
      data: params
    });
  },

  zyghIndex2(params) {
    return service({
      url: "/v2/index2",
      method: "post",
      data: params
    });
  },

  zyghIndex3(params) {
    return service({
      url: "/v2/index3",
      method: "post",
      data: params
    });
  },

  // 职规赛分页
  zyghPage(params) {
    return service({
      url: "/v2/page",
      method: "post",
      data: params
    });
  },

  // 职规赛-按模块查看全部文件分页
  zyghModulePage(params) {
    return service({
      url: "/v2/module/page",
      method: "post",
      data: params
    });
  },

  zyghPage1(params) {
    return service({
      url: "/v2/page1",
      method: "post",
      data: params
    });
  },

  zyghPage2(params) {
    return service({
      url: "/v2/page2",
      method: "post",
      data: params
    });
  },

  zyghPage3(params) {
    return service({
      url: "/v2/page3",
      method: "post",
      data: params
    });
  },

  // 职规赛轮播图
  zyghIndexAd(params) {
    return service({
      url: "/v2/index/ad",
      method: "get",
      params
    });
  },

  // 职规赛消息
  zyghIndexMsg(params) {
    return service({
      url: "/v2/index/msg",
      method: "get",
      params
    });
  },

  zyghIndexMsgadd(params) {
    return service({
      url: "/v2/index/msgadd",
      method: "post",
      data: params
    });
  },

  // =================== 职规赛页面专用接口 ===================
  
  // 职规赛首页数据
  indexVtwo(params) {
    return this.zyghIndex(params);
  },

  // 职规赛简历导航
  indexVResume(params) {
    return this.zyghIndex1(params);
  },

  // 职规赛就业能力
  indexVThree(params) {
    return this.zyghIndex2(params);
  },

  // 职规赛生涯发展
  indexVFour(params) {
    return this.zyghIndex3(params);
  },

  // 职规赛评论
  indexComment(params) {
    return this.zyghIndexMsg(params);
  },

  // 职规赛轮播图
  indexSwiper(params) {
    return this.zyghIndexAd(params);
  },

  // 职规赛搜索
  searchkeyHome(params) {
    return this.zyghPage(params);
  },

  // 职规赛简历搜索
  searchkeyResume(params) {
    return this.zyghPage1(params);
  },

  // 职规赛就业能力搜索
  searchkeyThree(params) {
    return this.zyghPage2(params);
  },

  // 职规赛生涯发展搜索
  searchkeyFour(params) {
    return this.zyghPage3(params);
  },

  // 职规赛模块分页
  modulePage(params) {
    return this.zyghModulePage(params);
  },


  // =================== 用户模块 ===================
  
  // 用户信息
  myinfo(params) {
    return service({
      url: "/my/info",
      method: "post",
      data: {
        token: params.token
      }
    });
  },

  // 更新用户信息
  myupdate(params) {
    return service({
      url: "/my/update",
      method: "post",
      data: params
    });
  },

  // 我的收藏
  mylike(params) {
    return service({
      url: "/my/like",
      method: "get",
      params: params.params || params
    });
  },

  // 我的下载
  mydownload(params) {
    return service({
      url: "/my/download",
      method: "get",
      params: params.params || params
    });
  },

  // 修改密码
  changepw(params) {
    return service({
      url: "/my/changepw",
      method: "post",
      data: {
        oldpw: params.oldpw,
        newpw: params.newpw
      }
    });
  },

  // 电子卡查询
  myecardquery(params) {
    return service({
      url: "/my/ecard/query",
      method: "post",
      data: params
    });
  },

  // 电子卡绑定
  myecardbind(params) {
    return service({
      url: "/my/ecard/bind",
      method: "post",
      data: params
    });
  },

  // =================== 收藏模块 ===================
  
  // 收藏/取消收藏
  collectionlike(params) {
    return this.like(params);
  },

  // =================== 新文科模块 ===================
  
  // 新文科首页数据（包含分类菜单和四大模块数据）
  getXinWenKeIndex(params) {
    return service({
      url: "/xinwenke/user/index",
      method: "post",
      data: params
    });
  },

  // 新文科分类页面数据（根据分类ID返回分页数据）
  getXinWenKeCategory(params) {
    return service({
      url: "/xinwenke/user/category",
      method: "post",
      data: params
    });
  },

  // 新文科分类菜单（不包含分页数据）
  getXinWenKeCategories(params) {
    return service({
      url: "/xinwenke/user/menu",
      method: "get",
      params
    });
  },

  // 新文科子分类列表
  getXinWenKeSubcategories(params) {
    return service({
      url: "/subcategory/list",
      method: "get",
      params
    });
  },

  // 新文科文件列表
  getXinWenKeFiles(params) {
    return service({
      url: "/xinwenke/user/category",
      method: "post",
      data: params
    });
  },

  // 新文科轮播图
  getXinWenKeBanners(params) {
    return service({
      url: "/xinwenke/user/banners",
      method: "get",
      params
    });
  },

  // 新文科推荐文件
  getXinWenKeRecommend(params) {
    return service({
      url: "/xinwenke/user/recommend",
      method: "get",
      params
    });
  },

  // 新文科用户行为 - 点赞/取消点赞
  likeXinWenKeFile(params) {
    return service({
      url: "/xinwenke/user/like",
      method: "post",
      data: params
    });
  },

  // 新文科下载记录
  downloadXinWenKeFile(params) {
    return service({
      url: "/xinwenke/user/download",
      method: "post",
      data: params
    });
  },

  // 新文科电子卡绑定
  bindXinWenKeEcard(params) {
    return service({
      url: "/xinwenke/user/ecard/bind",
      method: "post",
      data: params
    });
  },

  // 新文科电子卡状态查询
  getXinWenKeEcardStatus(params) {
    return service({
      url: "/xinwenke/user/ecard/status",
      method: "get",
      params
    });
  },

  // =================== 兼容性方法 ===================
  
  // 新文科首页
  xinwenkeIndex(params) {
    return this.getXinWenKeIndex(params);
  },

  // 新文科分类
  xinwenkeCategory(params) {
    return this.getXinWenKeCategory(params);
  },

  // 新文科菜单
  xinwenkeMenu(params) {
    return this.getXinWenKeCategories(params);
  },

  // 新文科轮播图
  xinwenkeBanners(params) {
    return this.getXinWenKeBanners(params);
  },

  // 新文科文件预览
  xinwenkePreview(params) {
    return this.previewXinWenKeFile(params.code, params.token);
  },

  // 新文科推荐
  xinwenkeRecommend(params) {
    return this.getXinWenKeRecommend(params);
  },

  // 新文科用户行为
  xinwenkeLike(params) {
    return this.likeXinWenKeFile(params);
  },

  xinwenkeDownload(params) {
    return this.downloadXinWenKeFile(params);
  },

  // 新文科电子卡
  xinwenkeEcardBind(params) {
    return this.bindXinWenKeEcard(params);
  },

  xinwenkeEcardStatus(params) {
    return this.getXinWenKeEcardStatus(params);
  },

  // 获取用户电子卡模块权限
  getUserEcardModulePermissions(onlinetoken) {
    return service({
      url: "/xinwenke/user/ecard-modules",
      method: "get",
      params: {
        onlinetoken: onlinetoken
      }
    });
  },

  // 新文科电子卡模块
  xinwenkeEcardModules(params) {
    return this.getUserEcardModulePermissions(params.onlinetoken);
  },

  // =================== 认证模块 ===================
  
  // 管理员登录
  adminLogin(params) {
    return service({
      url: "/api/auth/login",
      method: "post",
      data: {
        username: params.username || params.mobile,
        password: params.password
      }
    });
  },

  // 管理员验证码登录
  adminLoginByCode(params) {
    return service({
      url: "/api/auth/login-by-code",
      method: "post",
      data: {
        mobile: params.mobile,
        code: params.code
      }
    });
  },

  // 发送管理员登录验证码
  sendAdminLoginCode(params) {
    return service({
      url: "/api/auth/send-login-code",
      method: "post",
      data: {
        mobile: params.mobile
      }
    });
  },

  // 获取管理员当前用户信息
  getAdminCurrentUser(params) {
    return service({
      url: "/api/auth/me",
      method: "get",
      headers: {
        Authorization: `Bearer ${params.token}`
      }
    });
  },

  // 管理员登出
  adminLogout(params) {
    return service({
      url: "/api/auth/logout",
      method: "post",
      data: params
    });
  },

  // =================== 普通用户登录模块 ===================
  
  // 普通用户登录
  userLogin(params) {
    return service({
      url: "/user/login",
      method: "post",
      data: {
        type: params.type,
        account: params.account,
        password: params.password
      }
    });
  },

  // 普通用户注册
  userRegister(params) {
    return service({
      url: "/user/regist",
      method: "post",
      data: {
        account: params.account,
        captcha: params.captcha,
        passwd: params.passwd,
        state: 1
      }
    });
  },

  // 发送普通用户登录验证码
  sendUserLoginSms(params) {
    return service({
      url: "/user/sms/login",
      method: "post",
      data: {
        account: params.account
      }
    });
  },

  // 发送普通用户注册验证码
  sendUserRegisterSms(params) {
    return service({
      url: "/user/sms/regist",
      method: "post",
      data: {
        account: params.account
      }
    });
  },

  // 发送普通用户重置密码验证码
  sendUserResetSms(params) {
    return service({
      url: "/user/sms/resetpwd",
      method: "post",
      data: {
        account: params.account
      }
    });
  },

  // 普通用户重置密码
  resetPassword(params) {
    return service({
      url: "/user/resetpwd",
      method: "post",
      data: {
        account: params.account,
        password: params.password,
        captcha: params.captcha
      }
    });
  },

  // KTO登录
  loginkto(params) {
    return service({
      url: "/user/kto",
      method: "post",
      data: params
    });
  },

  // =================== 搜索模块 ===================
  
  // 获取搜索目录
  searchCatalog(params) {
    return service({
      url: "/search/catalog",
      method: "post",
      data: params
    });
  },

  // 关键词搜索
  searchKey(params) {
    return service({
      url: "/search/key",
      method: "post",
      data: params
    });
  },

  // 获取热门搜索
  searchTop(params) {
    return service({
      url: "/search/top",
      method: "get",
      params
    });
  },

  // =================== 搜索页面接口 ===================
  
  // 搜索关键词
  searchkey(params) {
    return this.searchKey(params);
  },

  // 获取搜索目录
  catalog(params) {
    return this.searchCatalog(params);
  },

  // 获取热门搜索
  searchtop(params) {
    return this.searchTop(params);
  },

  // =================== 订单模块 ===================
  
  // 查询订单（小写版本，实际使用）
  orderquery(params) {
    return service({
      url: "/order/query",
      method: "get",
      params: params.params || params
    });
  },

  // 订单交易（小写版本，实际使用）
  ordertrade(params) {
    return service({
      url: "/order/trade",
      method: "post",
      data: params
    });
  },

  // 订单支付（小写版本，实际使用）
  orderpay(params) {
    return service({
      url: "/order/pay",
      method: "post",
      data: params
    });
  },

  // 订单退款（小写版本，实际使用）
  orderreturn(params) {
    return service({
      url: "/order/return",
      method: "post",
      data: params
    });
  },

  // 创建订单
  orderBuy(params) {
    return service({
      url: "/order/buy",
      method: "post",
      data: params
    });
  },

  // KTO支付
  orderKto(params) {
    return service({
      url: "/order/kto",
      method: "post",
      data: params
    });
  },

  // =================== 新文科模块 ===================
  
  // 批量下载文件
  xinwenkeAdminBatchDownload(params) {
    return service({
      url: "/xinwenke/admin/batch-download-direct",
      method: "post",
      data: params,
      responseType: 'blob'
    });
  },

  // 创建新文科文件（管理员上传接口）
  createXinWenKeFile(params) {
    return service({
      url: "/xinwenke/admin/upload",
      method: "post",
      data: params,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // 通用文件上传接口（支持互联网+、职规赛等模块）
  universalUpload(params) {
    return service({
      url: "/xinwenke/admin/upload/universal",
      method: "post",
      data: params,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // 获取标签初始化数据接口
  getTagInitData(params) {
    return service({
      url: "/xinwenke/admin/source-tag/init",
      method: "get",
      params
    });
  },

  // 动态查询标签列表接口
  getTagList(params) {
    return service({
      url: "/xinwenke/admin/source-tag/list",
      method: "post",
      data: params
    });
  },

  // 创建标签
  createTag(params) {
    return service({
      url: "/xinwenke/admin/source-tag/create",
      method: "post",
      data: params
    });
  },

  // 更新标签
  updateTag(params) {
    return service({
      url: "/xinwenke/admin/source-tag/update",
      method: "put",
      data: params
    });
  },

  // 删除标签
  deleteTag(id) {
    return service({
      url: `/xinwenke/admin/source-tag/${id}`,
      method: "delete"
    });
  },

  // 批量删除标签
  batchDeleteTags(params) {
    return service({
      url: "/xinwenke/admin/source-tag/batch-delete",
      method: "post",
      data: params
    });
  },

  // 单个排序调整
  updateTagSequ(params) {
    return service({
      url: "/xinwenke/admin/source-tag/update-sequ",
      method: "put",
      data: params
    });
  },

  // 批量排序调整
  batchUpdateTagSequ(params) {
    return service({
      url: "/xinwenke/admin/source-tag/batch-update-sequ",
      method: "put",
      data: params
    });
  },

  // 名称唯一性校验
  checkTagName(params) {
    return service({
      url: "/xinwenke/admin/source-tag/check-name",
      method: "post",
      data: params
    });
  },

  // =================== 创新赛片段管理 ===================
  // 获取片段列表（parentCode必填）
  getFragmentList(params) {
    return service({
      url: "/xinwenke/admin/fragments",
      method: "get",
      params
    });
  },

  // 获取片段详情
  getFragmentDetail(params) {
    return service({
      url: `/xinwenke/admin/fragments/${params.code}`,
      method: "get"
    });
  },

  // 创建片段
  createFragment(data) {
    return service({
      url: "/xinwenke/admin/fragments",
      method: "post",
      data,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  // 更新片段
  updateFragment(params) {
    return service({
      url: `/xinwenke/admin/fragments/${params.code}`,
      method: "put",
      data: params.data,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },

  // 删除片段
  deleteFragment(params) {
    return service({
      url: `/xinwenke/admin/fragments/${params.code}`,
      method: "delete"
    });
  },

  // 批量上传文件
  xinwenkeAdminBatchUpload(params) {
    return service({
      url: "/xinwenke/admin/batch-upload",
      method: "post",
      data: params
    });
  },

  // 获取文件列表
  xinwenkeAdminGetFiles(params) {
    return service({
      url: "/xinwenke/admin/files",
      method: "post",
      params
    });
  },

  // 按格式查询文件
  xinwenkeAdminGetFilesByFormat(params) {
    return service({
      url: "/xinwenke/admin/files/by-format",
      method: "post",
      params
    });
  },

  // 根据ID获取文件详情
  xinwenkeAdminGetFileById(params) {
    return service({
      url: `/xinwenke/admin/file/${params.id}`,
      method: "get"
    });
  },

  // 删除文件
  xinwenkeAdminDeleteFile(params) {
    return service({
      url: `/xinwenke/admin/file/${params.id}`,
      method: "delete"
    });
  },

  // 修改旧模块文件
  xinwenkeAdminUpdateLegacyFile(params) {
    return service({
      url: "/xinwenke/admin/file/legacy/update",
      method: "put",
      data: params
    });
  },

  // 修改新文科文件
  xinwenkeAdminUpdateMathubFile(params) {
    return service({
      url: "/xinwenke/admin/file/mathub/update",
      method: "put",
      data: params
    });
  },

  // 生成文件编码
  xinwenkeAdminGenerateCode(params) {
    return service({
      url: "/xinwenke/admin/generate-code",
      method: "get"
    });
  },

  // 查询SourceIndex模块文件
  xinwenkeAdminGetSourceIndexFiles(params) {
    return service({
      url: "/xinwenke/admin/files/source-index",
      method: "post",
      params
    });
  },

  // 查询SourceIndexZyhg模块文件
  xinwenkeAdminGetSourceZyhgFiles(params) {
    return service({
      url: "/xinwenke/admin/files/source-zyhg",
      method: "post",
      params
    });
  },

  // 统一动态查询
  xinwenkeAdminQuery(params) {
    return service({
      url: "/xinwenke/admin/query",
      method: "post",
      data: params
    });
  },

  // 获取文件格式列表
  xinwenkeAdminGetFormats(params) {
    return service({
      url: "/xinwenke/admin/formats",
      method: "get"
    });
  },

  // 根据编码获取文件详情
  xinwenkeAdminGetFileByCode(params) {
    return service({
      url: `/xinwenke/admin/file/code/${params.code}`,
      method: "get"
    });
  },

  // 获取新文科电子卡列表
  xinwenkeAdminGetEcards(params) {
    return service({
      url: "/xinwenke/admin/ecard/list",
      method: "post",
      params
    });
  },

  // 查询新文科电子卡
  xinwenkeAdminEcardQuery(params) {
    return service({
      url: "/xinwenke/admin/ecard/query",
      method: "post",
      data: params
    });
  },

  // 生成电子卡密码
  xinwenkeAdminGenerateEcardPassword(params) {
    return service({
      url: "/xinwenke/admin/ecard/generate-password",
      method: "post"
    });
  },

  // 创建电子卡
  xinwenkeAdminCreateEcard(params) {
    return service({
      url: "/xinwenke/admin/ecard/create",
      method: "post",
      data: params
    });
  },

  // 获取电子卡绑定记录
  xinwenkeAdminGetEcardBindRecords(params) {
    return service({
      url: `/xinwenke/admin/ecard/${params.ecardId}/bind-records`,
      method: "get",
      params
    });
  },

  // 获取轮播图列表
  xinwenkeAdminGetBanners(params) {
    return service({
      url: "/xinwenke/admin/banner/list",
      method: "post",
      params
    });
  },

  // 创建轮播图
  xinwenkeAdminCreateBanner(params) {
    return service({
      url: "/xinwenke/admin/banner/create",
      method: "post",
      data: params
    });
  },

  // 更新轮播图
  xinwenkeAdminUpdateBanner(params) {
    return service({
      url: "/xinwenke/admin/banner/update",
      method: "put",
      data: params
    });
  },

  // 删除轮播图
  xinwenkeAdminDeleteBanner(params) {
    return service({
      url: `/xinwenke/admin/banner/${params.id}`,
      method: "delete"
    });
  },

  // 根据ID获取轮播图详情
  xinwenkeAdminGetBannerById(params) {
    return service({
      url: `/xinwenke/admin/banner/${params.id}`,
      method: "get"
    });
  },

  // 批量更新轮播图状态
  xinwenkeAdminBatchUpdateBannerState(params) {
    return service({
      url: "/xinwenke/admin/banner/batch-update-state",
      method: "put",
      data: params
    });
  },

  // 获取轮播图详情（根据ID）
  xinwenkeAdminGetBannerDetail(params) {
    return service({
      url: `/xinwenke/admin/banner/${params.id}`,
      method: "get"
    });
  },

  // 更新轮播图状态
  xinwenkeAdminUpdateBannerStatus(params) {
    return service({
      url: `/xinwenke/admin/banner/${params.id}/status`,
      method: "put",
      data: params
    });
  },

  // 获取所有学校列表
  xinwenkeAdminGetAllSchools(params) {
    return service({
      url: "/xinwenke/admin/schools",
      method: "get"
    });
  },

  // 搜索学校
  xinwenkeAdminSearchSchools(params) {
    return service({
      url: "/xinwenke/admin/schools/search",
      method: "get",
      params
    });
  },

  // 根据ID获取学校详情
  xinwenkeAdminGetSchoolById(params) {
    return service({
      url: `/xinwenke/admin/schools/${params.id}`,
      method: "get"
    });
  },

  // 根据编码获取学校详情
  xinwenkeAdminGetSchoolByCode(params) {
    return service({
      url: `/xinwenke/admin/schools/code/${params.code}`,
      method: "get"
    });
  },

  // =================== 文件管理接口 ===================
  
  // 获取分类列表
  getCategories(params) {
    return this.getXinWenKeCategories(params);
  },

  // 获取文件格式列表
  getFileFormats(params) {
    return this.xinwenkeAdminGetFormats(params);
  },

  // 获取子分类列表
  getSubcategories(params) {
    return this.getXinWenKeSubcategories(params);
  },

  // 获取新文科文件详情
  getXinWenKeFileDetail(params) {
    return this.xinwenkeAdminGetFileByCode(params);
  },

  // 获取SourceIndex文件详情
  getSourceIndexFileDetail(params) {
    return this.xinwenkeAdminGetFileByCode(params);
  },

  // 获取SourceZyhg文件详情
  getSourceZyhgFileDetail(params) {
    return this.xinwenkeAdminGetFileByCode(params);
  },

  // 删除新文科文件
  deleteXinWenKeFile(params) {
    return this.xinwenkeAdminDeleteFile(params);
  },

  // 预览新文科文件（修正参数格式）
  previewXinWenKeFile(params) {
    if (typeof params === 'string') {
      return service({
        url: "/xinwenke/user/preview",
        method: "get",
        params: { code: params, token: '' }
      });
    }
    return service({
      url: "/xinwenke/user/preview",
      method: "get",
      params: { code: params.code, token: params.token }
    });
  },

  // 批量下载文件
  batchDownloadFiles(params) {
    return this.xinwenkeAdminBatchDownload(params);
  },

  // 获取新文科文件列表
  getXinWenKeFileList(params) {
    return this.xinwenkeAdminGetFiles(params);
  },

  // 获取SourceIndex文件列表
  getSourceIndexFiles(params) {
    return this.xinwenkeAdminGetSourceIndexFiles(params);
  },

  // 查询新文科文件
  queryXinWenKeFiles(params) {
    return this.xinwenkeAdminQuery(params);
  },

  // 获取SourceZyhg文件列表
  getSourceZyhgFiles(params) {
    return this.xinwenkeAdminGetSourceZyhgFiles(params);
  },

  // 获取文件详情（通用方法）
  getFileDetail(params) {
    return this.xinwenkeAdminGetFileByCode(params);
  },

  // 删除文件（通用方法）
  deleteFile(params) {
    return this.xinwenkeAdminDeleteFile(params);
  },

  // 更新文件（通用方法）
  updateFile(params) {
    if (params.module === 'xinwenke') {
      return this.xinwenkeAdminUpdateMathubFile(params);
    } else {
      return this.xinwenkeAdminUpdateLegacyFile(params);
    }
  },

  // =================== 电子卡管理接口 ===================
  
  // 获取学校列表
  getSchoolList(params) {
    return this.xinwenkeAdminGetAllSchools(params);
  },

  // 获取新文科电子卡列表
  getXinWenKeEcardList(params) {
    return this.xinwenkeAdminGetEcards(params);
  },

  // 获取新文科电子卡绑定记录
  getXinWenKeEcardBindRecords(ecardId, params) {
    return this.xinwenkeAdminGetEcardBindRecords({ ecardId, ...params });
  },

  // 生成新文科电子卡密码
  generateXinWenKeEcardPassword(params) {
    return this.xinwenkeAdminGenerateEcardPassword(params);
  },

  // 创建新文科电子卡
  createXinWenKeEcard(params) {
    return this.xinwenkeAdminCreateEcard(params);
  },

  // 更新电子卡状态
  updateEcardStatus(params) {
    return service({
      url: `/xinwenke/admin/ecard/${params.id}/status`,
      method: "put",
      data: params
    });
  },

  // 删除电子卡
  deleteEcard(params) {
    return service({
      url: `/xinwenke/admin/ecard/${params.id}`,
      method: "delete"
    });
  },

  // 获取电子卡详情
  getEcardDetail(params) {
    return service({
      url: `/xinwenke/admin/ecard/${params.id}`,
      method: "get"
    });
  },

  // =================== 电子卡转换接口 ===================
  
  // 查询新文科电子卡
  queryXinWenKeEcard(params) {
    return this.xinwenkeAdminEcardQuery(params);
  },

  // 绑定新文科电子卡
  bindXinWenKeEcardAlias(params) {
    return this.bindXinWenKeEcard(params);
  },

  // =================== 分类管理接口 ===================
  
  // 更新分类
  updateCategory(params) {
    return service({
      url: "/xinwenke/admin/category/update",
      method: "put",
      data: params
    });
  },

  // 创建分类
  createCategory(params) {
    return service({
      url: "/xinwenke/admin/category/create",
      method: "post",
      data: params
    });
  },

  // 更新子分类
  updateSubcategory(params) {
    return service({
      url: "/xinwenke/admin/subcategory/update",
      method: "put",
      data: params
    });
  },

  // 创建子分类
  createSubcategory(params) {
    return service({
      url: "/xinwenke/admin/subcategory/create",
      method: "post",
      data: params
    });
  },

  // 删除分类
  deleteCategory(params) {
    return service({
      url: `/xinwenke/admin/category/${params}`,
      method: "delete"
    });
  },

  // 删除子分类
  deleteSubcategory(params) {
    return service({
      url: `/xinwenke/admin/subcategory/${params}`,
      method: "delete"
    });
  },

  // 获取分类详情
  getCategoryDetail(params) {
    return service({
      url: `/xinwenke/admin/category/${params.id}`,
      method: "get"
    });
  },

  // 获取子分类详情
  getSubcategoryDetail(params) {
    return service({
      url: `/xinwenke/admin/subcategory/${params.id}`,
      method: "get"
    });
  },

  // 更新分类状态
  updateCategoryStatus(params) {
    return service({
      url: `/xinwenke/admin/category/${params.id}/status`,
      method: "put",
      data: params
    });
  },

  // 更新子分类状态
  updateSubcategoryStatus(params) {
    return service({
      url: `/xinwenke/admin/subcategory/${params.id}/status`,
      method: "put",
      data: params
    });
  },

  // =================== 用户登录模块 ===================
  
  // 发送登录验证码
  smslogin(params) {
    return this.sendUserLoginSms(params);
  },

  // 发送注册验证码
  smsregist(params) {
    return this.sendUserRegisterSms(params);
  },

  // 发送重置密码验证码
  smsresetpwd(params) {
    return this.sendUserResetSms(params);
  },

  // 重置密码
  czresetpwd(params) {
    return this.resetPassword(params);
  },

  // 用户登录
  login(params) {
    return this.userLogin(params);
  },

  // 用户注册
  regist(params) {
    return this.userRegister(params);
  },

  // =================== 通用工具方法 ===================
  
  // 文件上传（通用方法）
  uploadFile(params) {
    return service({
      url: "/file/upload",
      method: "post",
      data: params,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },


};

// 轮播图管理API模块
export const bannerApi = {
  // 获取轮播图列表
  getBannerList(params) {
    return service({
      url: "/xinwenke/admin/banner/list",
      method: "post",
      params
    });
  },

  // 创建轮播图
  createBanner(data) {
    return service({
      url: "/xinwenke/admin/banner/create",
      method: "post",
      data
    });
  },

  // 更新轮播图
  updateBanner(data) {
    return service({
      url: "/xinwenke/admin/banner/update",
      method: "put",
      data
    });
  },

  // 删除轮播图
  deleteBanner(id) {
    return service({
      url: `/xinwenke/admin/banner/${id}`,
      method: "delete"
    });
  },

  // 获取轮播图详情
  getBannerDetail(id) {
    return service({
      url: `/xinwenke/admin/banner/${id}`,
      method: "get"
    });
  },

  // 批量更新轮播图状态
  batchUpdateState(data) {
    return service({
      url: "/xinwenke/admin/banner/batch-update-state",
      method: "put",
      data
    });
  }
};
